module.exports = __webpack_public_path__ + "static/media/user-store-icon1.png";